export default __webpack_public_path__ + "static/sicoob-2cf4d639a13ece73fddf920debc0748e.png";